/**
 * 🎁 NEW CLIENT BANNER - Bandeau promotion nouveau client
 * Style spatial avec shimmer effect
 */

import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const NewClientBanner = ({ className = '' }) => {
  const navigate = useNavigate();

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 1.5 }}
      className={`mt-6 ${className}`}
    >
      <motion.button
        onClick={() => navigate('/offre-bienvenue')}
        animate={{ 
          boxShadow: [
            '0 0 15px rgba(255, 215, 0, 0.3), 0 0 30px rgba(0, 255, 255, 0.2)',
            '0 0 30px rgba(255, 215, 0, 0.6), 0 0 50px rgba(0, 255, 255, 0.4)',
            '0 0 15px rgba(255, 215, 0, 0.3), 0 0 30px rgba(0, 255, 255, 0.2)'
          ]
        }}
        transition={{ duration: 2, repeat: Infinity, ease: "easeInOut" }}
        whileHover={{ scale: 1.02 }}
        whileTap={{ scale: 0.98 }}
        className="w-full p-5 rounded-2xl border-2 text-center relative overflow-hidden"
        style={{
          background: 'linear-gradient(135deg, rgba(255, 215, 0, 0.15) 0%, rgba(0, 255, 255, 0.1) 100%)',
          borderColor: '#FFD700'
        }}
        data-testid="new-client-banner"
      >
        {/* Shimmer effect */}
        <motion.div
          className="absolute inset-0 pointer-events-none"
          style={{
            background: 'linear-gradient(90deg, transparent, rgba(255,255,255,0.2), transparent)',
          }}
          animate={{ x: ['-100%', '200%'] }}
          transition={{ duration: 3, repeat: Infinity, repeatDelay: 1 }}
        />
        <p className="text-yellow-400 font-bold text-lg relative z-10">🚀 Première visite ? On t'offre -10% !</p>
        <p className="text-white text-sm mt-1 relative z-10">Rejoins l'équipage <span className="text-cyan-400 font-bold">LPE</span> et décolle avec ton cadeau !</p>
        <p className="text-cyan-300 text-xs mt-2 underline relative z-10">Embarque maintenant →</p>
      </motion.button>
    </motion.div>
  );
};

export default NewClientBanner;
